import { jsPDF } from "jspdf";

const NAVY = [15, 23, 42];
const TERRA = [197, 90, 56];
const GREY = [100, 116, 139];
const DARK = [17, 17, 17];

export function generateReportPdf(event, report) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 48;
  const CW = W - M * 2;
  let y = 0;

  const ensure = (need) => { if (y + need > H - 56) { footer(); doc.addPage(); y = M; } };

  // Header band
  doc.setFillColor(...NAVY);
  doc.rect(0, 0, W, 84, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold"); doc.setFontSize(20);
  doc.text("Pitso", M, 50);
  const pw = doc.getTextWidth("Pitso");
  doc.setTextColor(...TERRA); doc.text("IO", M + pw, 50);
  doc.setTextColor(255, 255, 255); doc.setFont("helvetica", "normal"); doc.setFontSize(9);
  doc.text("Executive Event Report", M, 66);
  doc.setFontSize(9); doc.setTextColor(200, 210, 225);
  const gen = report.generated_at ? new Date(report.generated_at).toLocaleString() : new Date().toLocaleString();
  doc.text(gen, W - M, 50, { align: "right" });
  y = 108;

  // Event title
  doc.setTextColor(...DARK); doc.setFont("helvetica", "bold"); doc.setFontSize(18);
  const titleLines = doc.splitTextToSize(event?.name || "Event Report", CW);
  doc.text(titleLines, M, y); y += titleLines.length * 22 + 6;
  if (event?.venue || event?.location || event?.date) {
    doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(...GREY);
    doc.text([event.venue, event.location, event.date].filter(Boolean).join("  ·  "), M, y); y += 20;
  }
  doc.setDrawColor(226, 232, 240); doc.line(M, y, W - M, y); y += 24;

  const content = report.content || {};

  const section = (title, body) => {
    ensure(60);
    doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(...TERRA);
    doc.text(title.toUpperCase(), M, y); y += 16;
    doc.setTextColor(...DARK);
    if (Array.isArray(body)) {
      doc.setFont("helvetica", "normal"); doc.setFontSize(10.5);
      body.filter(Boolean).forEach((item) => {
        const lines = doc.splitTextToSize(item, CW - 16);
        ensure(lines.length * 15 + 4);
        doc.setFillColor(...TERRA); doc.circle(M + 3, y - 3.5, 1.6, "F");
        doc.text(lines, M + 14, y); y += lines.length * 15 + 5;
      });
    } else if (body) {
      doc.setFont("helvetica", "normal"); doc.setFontSize(10.5);
      const lines = doc.splitTextToSize(body, CW);
      ensure(lines.length * 15);
      doc.text(lines, M, y); y += lines.length * 15;
    }
    y += 14;
  };

  const footer = () => {
    doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(...GREY);
    doc.text("Generated by PitsoIO · Meet. Connect. Engage.", M, H - 28);
  };

  section("Executive Summary", content.executive_summary);
  section("Key Themes", content.key_themes);
  section("Audience Questions", content.audience_questions);
  section("Session Feedback", content.session_feedback);
  section("Top Concerns", content.top_concerns);
  section("Recommendations", content.recommendations);
  section("Action Items", content.action_items);
  footer();

  const safe = (event?.name || "event").replace(/[^a-z0-9]+/gi, "-").toLowerCase();
  doc.save(`pitsoio-report-${safe}.pdf`);
}
